/**
 * Deeliver Customers — placeholder under CUSTOMERS (Jason, 5 Nov 2026: "can just say coming soon").
 *
 * @module pages/DeeliverCustomers
 */

import React from 'react';
import { Box, Typography } from '@mui/material';
import { Title } from 'react-admin';

import { useAdminTheme } from '../admin-theme';

export default function DeeliverCustomers() {
  const { colors } = useAdminTheme();
  return (
    <Box sx={{ p: 3 }}>
      <Title title="Deeliver Customers" />
      <Typography variant="h4" sx={{ color: colors.textPrimary, fontWeight: 800 }}>
        Deeliver Customers
      </Typography>
      <Typography variant="body1" sx={{ color: colors.textSecondary, mt: 1 }}>
        Coming soon.
      </Typography>
    </Box>
  );
}
